<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'InviteAuthenticateToken',
  async created() {
    this.startLoading(this.$options.name);
    await this.$store.dispatch('inviteSession/init', this.$route.query.accessToken);
    this.doneLoading(this.$options.name);
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/invite-authenticated/InviteAuthenticateToken.vue